import { useBrazilianMasks } from './useBrazilianMasks.js'

const { getWhatsAppLink } = useBrazilianMasks()

/**
 * Primeiro nome para saudação no WhatsApp.
 * Alinhado ao Navbar: `first_name` / `last_name` no `user` do `localStorage` (login da API).
 * Nunca usa e-mail. `name` só como legado se existir.
 */
export function getLoggedInUserFirstName() {
  if (typeof window === 'undefined') return ''
  try {
    const raw = localStorage.getItem('user')
    if (!raw) return ''
    const u = JSON.parse(raw)
    const fn = String(u.first_name || '').trim()
    if (fn) return fn.split(/\s+/)[0]
    const legacy = String(u.name || '').trim()
    if (legacy) return legacy.split(/\s+/)[0]
    return ''
  } catch {
    return ''
  }
}

/**
 * Monta o texto do WhatsApp: saudação com nome + frase + linha em branco + URL.
 * @param {string} restAfterGreeting — ex.: "Segue o link para você cadastrar os seus dados!" (sem o "Olá… aqui!")
 * @param {string} url
 */
export function buildWhatsAppMessageWithLink(restAfterGreeting, url) {
  const first = getLoggedInUserFirstName()
  const intro = first ? `Olá, tudo bem? ${first} aqui 😊` : 'Olá, tudo bem!'
  const body = `${intro} ${String(restAfterGreeting).trim()}`
  return `${body}\n\n${url}`
}

/**
 * Link para abrir o WhatsApp com texto pré-preenchido.
 * Com telefone BR válido: `wa.me/...?text=`.
 * Sem telefone: `api.whatsapp.com/send?text=` (o usuário escolhe o contato).
 */
export function getWhatsAppShareHref(phone, message) {
  const text = encodeURIComponent(message)
  const hasPhone = phone != null && String(phone).trim() !== ''
  const base = hasPhone ? getWhatsAppLink(phone) : null
  if (base) return `${base}?text=${text}`
  return `https://api.whatsapp.com/send?text=${text}`
}

export function openWhatsAppShare(phone, message) {
  const href = getWhatsAppShareHref(phone, message)
  window.open(href, '_blank', 'noopener,noreferrer')
}
